Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityMetricsCategoryBoxView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_metrics_category_box']
  className: 'operator-availability-metrics-category-box'

  initialize: ({@iconClassName, @metrics}) ->

  render: ->
    @$el.html(@template(iconClassName: @iconClassName))
    @metrics.forEach((metric) =>
      metricView = new Customer.Views.Reports.OperatorAvailabilityMetricView(metric: metric)
      @$el.append(metricView.render().el)
    )
    @$el.css('flex-grow', "#{@metrics.length}")
    @




